/* unplugin-vue-components disabled */import script from "./my_copy.vue?vue&type=script&setup=true&lang=js"
export * from "./my_copy.vue?vue&type=script&setup=true&lang=js"

import "./my_copy.vue?vue&type=style&index=0&id=70aea415&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70aea415"]])

export default __exports__